import moment from 'moment';
import { ContentControlledEditingDirective } from '../editing-directive/content-controlled-editing-directive';
import { ContentControlItemLinkedFile } from './content-control-item-linked-file';
import { ContentControlledLinkedFileMediaTypeEnum } from '../enums/content-controlled-linked-file-media-type.enum';
import { ContentControlledReportableEvent } from '../reportable-event/content-controlled-reportable-event';
import { IContentControlledItemSettings } from '../settings/i-content-controlled-item-settings';

export class ContentControlItem {
  public get isRendered(): boolean {
    return !!this.mediaTranscoderJobUid;
  }
  constructor(
    public uid: string,
    public mediaId: number,
    public mediaUniqueId: string,
    public mediaName: string,
    public snapshotUrl: string,
    public previewVideoUrl: string,
    public transcodingVideoUrl: string,
    public videoFps: number,
    public mediaTranscoderJobUid: string,
    public isAI: boolean,
    public isEdited: boolean,
    public aiJobUid: string,
    public uploadedDate: moment.Moment,
    public itemSettings: IContentControlledItemSettings,
    public reportableEvents: ContentControlledReportableEvent[] = [],
    public editingDirectives: ContentControlledEditingDirective[] = [],
    public linkedFiles: ContentControlItemLinkedFile[] = [],
    public hasAiJobsRunning: boolean,
    public mediaStartTimeStampMs?: number,
  ) {}
  get AudioFiles() {
    return this.linkedFiles.filter(
      (x) => x.fileType == ContentControlledLinkedFileMediaTypeEnum.Audio,
    );
  }
  get SubtitleFiles() {
    return this.linkedFiles.filter(
      (x) => x.fileType == ContentControlledLinkedFileMediaTypeEnum.Subtitle,
    );
  }
}
